import styled, { keyframes } from 'styled-components'

export const PatientHomepageSectionContainer = styled.div`
  background: #ded5f652;
  margin: 16px;
  padding: 16px;
  border-radius: 16px;
`

export const PatientProfileChoosingContainer = styled.div`
  width: 100vw;
  height: 100vh;
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  transition: all 0.25s linear;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 24px;
  background: ${(props) => (props?.faded ? 'transparent' : '#1E1E1E')};
`

export const PatientProfileItemContainer = styled.div`
  transition: all 0.75s ease;
  display: flex;
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  top: ${(props) => props.centerY}px;
  left: ${(props) => props.centerX}px;
  color: #fff;
  ${(props) =>
    props.selected &&
    `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `};
`

export const PHHeading = styled.div`
  font-weight: 700;
  font-size: ${(props) => (props?.big ? '20px' : '16px')};
  @media (min-width: 768px) {
    font-size: ${(props) => (props?.big ? '24px' : '20px')};
  }
`

export const PHStepStatus = styled.div`
  padding: 4px 8px;
  color: ${(props) => props?.accentBgColor || '#000'};
  // color: ${(props) => props?.accentColor || '#fff'};
  border-radius: 4px;
  width: fit-content;
  text-decoration: underline;
`

export const PHJoinButtonContainer = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background: orange;
  color: #fff;
  border-radius: 8px;
  aspect-ratio: 1;
  min-width: 50px;
  width: fit-content;
`

export const PHMentorImage = styled.img`
  aspect-ratio: 1;
  width: 60px;
  border-radius: 50%;
`

const flashAnimation = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

export const FlashingTokenNumber = styled.span`
  animation: ${flashAnimation} 2s infinite;
  width: fit-content;
  padding: 2px 4px;
  border-radius: 4px;
`

//
//
//
//
//
